<template>
  <ak-field label="Profile name" margin-bottom="mb-small" required>
    <ak-input
      v-model="profileName"
      placeholder="Enter profile name"
      maxlength="100"
      required
    />
  </ak-field>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'AkIntegrationSFTPProfile',
  props: {
    modelValue: {
      required: true,
      type: String,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const profileName = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    })

    return {
      profileName,
    }
  },
})
</script>
